module.exports = __webpack_public_path__ + "static/assets/4e99a40d22a42b60e4df85d52a8a4b5f.svg";